import axios from "../../axios";

const getInvoiceAdjustments = async () => {
  try {
    const { data } = await axios.get(`/adjustments/active?adjustment_level[$eq]=invoice&use_by_default[$eq]=true`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

export { getInvoiceAdjustments };